import React, { Component } from 'react';
import { format } from "date-fns";
import { Big3Common, bootstrap } from '../../../js/IncludeManager'
import { Big3DatePicker, NoResult, Alert } from "../../../js/ComponentManager";
/* 개발담당:양유빈
 * 화면기능:엑셀주문내역 리스트
 * 세부설명:
*/

export class OrderDtlExcel extends Component {
    static displayName = OrderDtlExcel.name;

    constructor(props) {
        super(props);
        this.fromDate = format(Big3Common.Util.DateAdd(new Date(), -10), "yyyy-MM-dd");
        this.toDate = format(Big3Common.Util.DateAdd(new Date(), 1), "yyyy-MM-dd");      
        this.state = {
            FromDate: this.fromDate,
            ToDate: this.toDate,    
            ExcelOrderMst: [],
            ExcelOrderList: [],
            Select_Order_Dt: "",
            Content:"",
            isOk: false
        };
        this.handleCalendarChange = this.handleCalendarChange.bind(this);
        this.handleSelect_Click = this.handleSelect_Click.bind(this);
    }
    //초기화
    componentDidMount() {
        this.CallExcelOrder();
    }
    //엑셀주문 조회
    CallExcelOrder = async () => {
        try {

            Big3Common.Util.LoadingOn();
            let Data = await Big3Common.Post('api/Common/ExcelOrder/GetExcelOrderMst',
                {
                    FromDate: this.state.FromDate,
                    ToDate: this.state.ToDate
                }, true);
            if (Data.codeName === Big3Common.ResultCode.Success) {
                const DataList = JSON.parse(Data.multiDataTable);
                const ExcelOrderMst = DataList.ExcelOrderMst;
                const ExcelOrderList = DataList.ExcelOrderList;
                this.setState({ ExcelOrderMst: ExcelOrderMst, ExcelOrderList: ExcelOrderList });
            }
            else {
                this.setState({ Content: Data.message });
                Big3Common.ModalAlert(bootstrap, "ExcelOrderAlert");
            }
        }
        catch (e) {
            console.log("CallRtiListData: ", e)
        }
        finally {
            Big3Common.Util.LoadingOff();
        }
        return false;
    }
    //달력일정 변경
    handleCalendarChange(retunValue) {
        let TagId = retunValue.returnId;
        this.setState({ [TagId]: retunValue.SelectDate });
        return false;
    }
    //상세보가, 접기 버튼
    handleSelect_Click(order_dt,flag) {
        this.setState({ Select_Order_Dt: flag === "open" ? order_dt : "" });
    }
    ExcelOrderList = (order_dt) => {
        const OrderList = this.state.ExcelOrderList.filter(list => list.order_dt === order_dt);
        return (
            OrderList.map((list,idx) =>
                <>
                    <div className="order_detail_info" key={idx+1}>
                        <div className="excel_order_info_box">
                            <div className="excel_order_info_tit">소매업체</div>
                            <div className="excel_order_retail_info">
                                <div className="excel_order_info_cont">{list.org_name}</div>
                                <div className="call" onClick={() => { window.location.href = `tel:${list.user_phone}` }}></div>
                            </div>
                        </div>
                        <div className="excel_order_info_box">
                            <div className="excel_order_info_tit">주문내용</div>
                            <div className="excel_order_staus">
                                {list.return_yn === "Y" ? <div className="return">반품</div> : ""}
                                {list.last_appr_status === "CP" ? <div className="order_c">완료</div> : <div className="order_ic">미완료</div>}
                            </div>
                        </div>
                        <div className="order_detail">
                            {list.retail_memo}
                        </div>
                    </div>  
                </>
            )
        )
    }
    ExcelOrderMst = () => {
        const excelOrderMst = this.state.ExcelOrderMst;
        //상세보기, 접기 버튼
        this.OpneClose = (order_dt) => {
            if (this.state.Select_Order_Dt === order_dt) {
                return (
                    <div className="order_detail_btn" onClick={() => { this.handleSelect_Click(order_dt,'close') }}>접기</div>
                )
            }
            else {
                return (
                    <div className="order_detail_btn" onClick={() => { this.handleSelect_Click(order_dt,'open') }}>상세보기</div>
                )
            }
        }
        return (
            excelOrderMst.map(list =>
                <div className="excel_order" key={list.order_dt}>
                    <div className="excel_order_info_box">
                        <div className="e_date">{list.format_order_dt}</div>
                        <div className="number">총 <span>{list.tot_cnt }</span>건</div>
                    </div>
                    {this.state.Select_Order_Dt === list.order_dt ? this.ExcelOrderList(list.order_dt) : ""}
                    {this.OpneClose(list.order_dt)}
                </div>
            )
        )
    }
    render() {
        return (
            <div className="container_box2 p_f_margin c_padding">
                <div className="search_box sb_v2">
                    <div className="select_date_box">
                        <div className="select_date_box_input">
                            <div>
                                <Big3DatePicker
                                    className="form-control"
                                    setDate={new Date(this.state.FromDate)}
                                    DateChange={this.handleCalendarChange}
                                    id="FromDate"
                                />
                            </div>
                        </div>
                        <div className="select_date_box_input">
                            <Big3DatePicker
                                className="form-control"
                                setDate={new Date(this.state.ToDate)}
                                DateChange={this.handleCalendarChange}
                                id="ToDate"
                            />
                        </div>
                        <button type="button" className="date_s_btn" onClick={() => { this.CallExcelOrder() } }>조회</button>
                    </div>
                </div>
                {this.ExcelOrderMst()}
                <NoResult
                    Visible={this.state.ExcelOrderMst.length === 0 ? true : false}
                    Top={"60%"}
                />
                <Alert
                    id="ExcelOrderAlert"
                    title="검색안내"
                    content={this.state.Content}
                />
            </div>
        )
    }
}